/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  're-indent-trans': {
    width: 8,
    height: 8,
    viewBox: '0 0 8 8',
    data: '<path pid="0" d="M7.687 6.93c.272.275.182.536-.2.58l-1.791.201c-.383.043-.661-.239-.619-.627l.2-1.816c.042-.388.3-.48.571-.203l.438.443c.261-.42.414-.918.414-1.452 0-1.51-1.211-2.738-2.7-2.738S1.3 2.546 1.3 4.056c0 1.232.807 2.276 1.913 2.619L3.068 8C1.308 7.574 0 5.97 0 4.056 0 1.816 1.79 0 4 0s4 1.816 4 4.056c0 .9-.29 1.729-.779 2.4l.466.473z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
